import { createContext } from '@web-stories-wp/react';

export default createContext({ state: {}, actions: {} });
